module.exports = __webpack_public_path__ + "static/img/Carts.34b303b1.svg";